import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description QA icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { QA } from '@sravni/design-system-icons'
 *
 * <QA />
 * ```
 */
var QA = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "QA", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.667 10.833v3.334M10 5.833v8.334M13.333 8.333v5.834M4.167 2.5h11.666c.921 0 1.667.746 1.667 1.667v11.666c0 .921-.746 1.667-1.667 1.667H4.167c-.921 0-1.667-.746-1.667-1.667V4.167c0-.921.746-1.667 1.667-1.667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { QA };
//# sourceMappingURL=QA.js.map
